<template>
    <!--
        Milo at work on something the person started (a confirm that translates and saves, docs/API.md
        §14.6.1): his still face, the words and three dots that bounce — still for a reader who has asked
        the system for less motion. A status region, so a screen reader hears it once.
    -->
    <div class="flex items-center gap-2 rounded-md bg-primary/10 px-2.5 py-1.5" role="status" aria-live="polite">
        <MiloFigure state="think" framing="head" :enable3d="false" class="size-8 shrink-0" />
        <p class="min-w-0 flex-1 text-sm text-highlighted">{{ text }}</p>
        <span class="flex shrink-0 items-end gap-1" aria-hidden="true">
            <span class="size-1.5 animate-bounce rounded-full bg-primary [animation-delay:-0.3s] motion-reduce:animate-none" />
            <span class="size-1.5 animate-bounce rounded-full bg-primary [animation-delay:-0.15s] motion-reduce:animate-none" />
            <span class="size-1.5 animate-bounce rounded-full bg-primary motion-reduce:animate-none" />
        </span>
    </div>
</template>

<script lang="ts" setup>
    import MiloFigure from '@/components/MiloFigure.vue'

    defineProps<{
        /** What Milo is doing, already in the console's language. */
        text: string
    }>()
</script>
